"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserPoolContributionNFT = void 0;
var react_1 = require("react");
var web3_utils_1 = require("web3-utils");
var _launchpadConstants_1 = require("../../launchpadConstants");
var _pool_1 = require("../../pool");
var _shared_1 = require("../../shared");
var utils_1 = require("../../shared/utils");
function useUserPoolContributionNFT() {
    var account = (0, _shared_1.useUser)().account;
    var _a = (0, _pool_1.usePool)(), sale = _a.pool.sale, saleInstance = _a.saleInstance;
    var _b = (0, react_1.useState)(sale.inventory.reduce(function (acc, item) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[item.id] = _launchpadConstants_1.ZERO_BN, _a)));
    }, {})), poolBalance = _b[0], setPoolBalance = _b[1];
    var _c = (0, react_1.useState)(_launchpadConstants_1.ZERO_BN), contributed = _c[0], setContributed = _c[1];
    function update() {
        saleInstance.methods
            .balanceAggregatedOf(account)
            .call()
            .then(function (_a) {
            var ids = _a[0], amounts = _a[1];
            var balance = ids.reduce(function (acc, item, k) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[(0, utils_1.bytes32ToString)(ids[k])] = (0, web3_utils_1.toBN)(amounts[k]), _a)));
            }, {});
            setPoolBalance(balance);
        });
        saleInstance.methods
            .contributed(account)
            .call()
            .then(function (v) { return setContributed((0, web3_utils_1.toBN)(v)); });
    }
    (0, react_1.useEffect)(function () {
        if (account && saleInstance) {
            update();
        }
    }, [account, saleInstance]);
    return {
        contributionCurrency: contributed,
        poolBalance: poolBalance,
        update: update,
    };
}
exports.useUserPoolContributionNFT = useUserPoolContributionNFT;
